var __jsx = React.createElement;
import React, { Fragment, useEffect, useState } from 'react';
const Transition = _ref => {
  let {
    show,
    as: Component = Fragment,
    children,
    enter = '',
    enterFrom = '',
    enterTo = '',
    leave = '',
    leaveFrom = '',
    leaveTo = ''
  } = _ref;
  const {
    0: isVisible,
    1: setIsVisible
  } = useState(show);
  const {
    0: isAnimating,
    1: setIsAnimating
  } = useState(false);
  useEffect(() => {
    if (show) {
      setIsVisible(true);
      setIsAnimating(true);
      // Force reflow to ensure enterFrom classes are applied
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setIsAnimating(false);
        });
      });
    } else {
      setIsAnimating(true);
      // Wait for leave animation to complete before hiding
      const timer = setTimeout(() => {
        setIsVisible(false);
        setIsAnimating(false);
      }, 75); // Default leave duration

      return () => clearTimeout(timer);
    }
  }, [show]);
  if (!isVisible) {
    return null;
  }
  const getTransitionClasses = () => {
    if (isAnimating) {
      if (show) {
        // Entering
        return "".concat(enter, " ").concat(enterFrom);
      } else {
        // Leaving
        return "".concat(leave, " ").concat(leaveFrom);
      }
    } else {
      // Stable state
      return show ? "".concat(enter, " ").concat(enterTo) : "".concat(leave, " ").concat(leaveTo);
    }
  };
  return __jsx(Component, {
    className: getTransitionClasses()
  }, children);
};
const TransitionChild = _ref2 => {
  let {
    as: Component = Fragment,
    children,
    enter = '',
    enterFrom = '',
    enterTo = '',
    leave = '',
    leaveFrom = '',
    leaveTo = ''
  } = _ref2;
  const {
    0: isAnimating,
    1: setIsAnimating
  } = useState(false);
  useEffect(() => {
    setIsAnimating(true);
    // Force reflow to ensure enterFrom classes are applied
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setIsAnimating(false);
      });
    });
  }, []);
  const getTransitionClasses = () => {
    if (isAnimating) {
      return "".concat(enter, " ").concat(enterFrom);
    } else {
      return "".concat(enter, " ").concat(enterTo);
    }
  };
  return __jsx(Component, {
    className: getTransitionClasses()
  }, children);
};
Transition.Child = TransitionChild;
export default Transition;